import { FC, useCallback, useState } from 'react';
import SeoContentPortal from '../../../misc/seo-content-portal';
import SeoContentSection from '../../../misc/seo-content-section';
import { useTypedTranslations } from '../../../translation/use-translations';
import { textKeyIsSet } from '../utils/sportsbook-route-utils';

const TEXT_KEY_READ_MORE = 'CONTENT_COMPONENT_READ_MORE';

type SeoContentTextKeys = {
	partOne: string;
	partTwo: string;
	readMore: string;
};

type SportsbookSeoLobbyFooterProps = {
	partOneTextKey: string;
	partTwoTextKey: string;
};

const SportsbookSeoLobbyFooter: FC<SportsbookSeoLobbyFooterProps> = ({ partOneTextKey, partTwoTextKey }) => {
	const seoContentTextKeys: SeoContentTextKeys = {
		partOne: partOneTextKey,
		partTwo: partTwoTextKey,
		readMore: TEXT_KEY_READ_MORE
	};

	const [isExpanded, setIsExpanded] = useState(false);

	const typedTranslations = useTypedTranslations(seoContentTextKeys);
	const handleOnExpand = useCallback(() => setIsExpanded(true), []);

	if (typedTranslations.isLoadingTranslations) {
		return null;
	}

	if (
		!textKeyIsSet(typedTranslations.translations[seoContentTextKeys.partOne]) ||
		!typedTranslations.translations[seoContentTextKeys.partOne]?.trim()
	) {
		return null;
	}

	return (
		<SeoContentPortal>
			<SeoContentSection
				partOne={typedTranslations.translations[seoContentTextKeys.partOne]}
				partTwo={typedTranslations.translations[seoContentTextKeys.partTwo]}
				isExpanded={isExpanded}
				onExpand={handleOnExpand}
				readMoreText={typedTranslations.translations[seoContentTextKeys.readMore]}
			/>
		</SeoContentPortal>
	);
};

export default SportsbookSeoLobbyFooter;
